import { FlexBox, Spinner, Text } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import * as React from 'react';
import OnClickOutside from 'react-onclickoutside';
import isEmail from 'validator/lib/isEmail';

import { Autocomplete } from '../util/autocomplete';

import styles from './AutocompleteUserAsync.module.scss';
import { isKeyToCloseDropdownInWindow } from './utils/dropdown';

type PropsT = {
  formName: string;
  className: string | null;
  status: string;
  elements: Array<any>;
  isShown: boolean;
  fields: any;
  getfunction: (searchValue: any) => Promise<any>;
  ElementItem: any;
  onFocusFunction: ((e: any) => void) | null;
  onBlurFunction: ((e: any) => void) | null;
  add: (payload: any) => void;
  touch: (form: string, field: string) => void;
  stopFormSubmit: ((form: string, erros: any) => void) | null;
  placeholder: string;
  numberOfResults: number;
};

type StateT = {
  value: string;
  isResultShown: boolean;
  highlightedIndex: number | null;
  emailUsers?: any;
};

class AutocompleteUserAsync extends React.Component<PropsT, StateT> {
  autocomplete: Autocomplete;
  input: React.RefObject<any>;

  constructor(props: PropsT) {
    super(props);
    this.input = React.createRef();
    this.state = {
      value: '',
      isResultShown: false,
      highlightedIndex: null,
    };

    this.onChangeInput = this.onChangeInput.bind(this);
    this.cleanPaste = this.cleanPaste.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.resetValue = this.resetValue.bind(this);
    this.focusNext = this.focusNext.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDownHandling = this.onKeyDownHandling.bind(this);
    this.getImmediate = this.getImmediate.bind(this);

    this.autocomplete = new Autocomplete(this.getImmediate);
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    // If `users` has changed we want to reset `highlightedIndex`
    // since it probably no longer refers to a relevant item.
    //
    // The entries in `users` may have been changed even though the
    // object reference remains the same, double check by seeing
    // if `highlightedIndex` points to an existing item.
    let emailUsers: any[] = [];
    let nextEmailUsers = [];
    if (this.props.elements.length > 0) {
      emailUsers = this.props.elements.filter(
        (user: any) => typeof user.email === 'string' && user.email !== '',
      );
    }

    if (nextProps.elements.length > 0) {
      nextEmailUsers = nextProps.elements.filter(
        (user: any) => typeof user.email === 'string' && user.email !== '',
      );
    }
    if (
      emailUsers !== nextEmailUsers ||
      (this.state.highlightedIndex as number) >= nextEmailUsers.length
    ) {
      this.setState({ highlightedIndex: null, emailUsers: nextEmailUsers });
    } else {
      this.setState({ emailUsers: nextEmailUsers });
    }
  }

  @boundMethod
  handleWindowKeydown(event: KeyboardEvent) {
    if (isKeyToCloseDropdownInWindow(event.key) && !!this.getRequesters()) {
      event.stopPropagation();
      this.handleClickOutside();
    }
  }

  componentDidMount(): void {
    window.addEventListener('keydown', this.handleWindowKeydown);
  }

  componentWillUnmount(): void {
    window.removeEventListener('keydown', this.handleWindowKeydown);
  }

  componentDidUpdate(prevProps: PropsT, prevState: StateT) {
    if (
      !prevState.isResultShown &&
      this.state.isResultShown &&
      this.input.current
    ) {
      this.input.current.focus();
    }
  }

  handleClickOutside() {
    this.setState({ isResultShown: false }, () => {
      if (this.state.value.trim() === '') {
        this.resetValue();
      }
    });
  }

  resetValue() {
    this.setState({ value: '', highlightedIndex: null });
  }

  getImmediate(searchValue) {
    return this.props.getfunction(searchValue);
  }

  onChangeInput(e: any) {
    // Prevent multiple spaces
    const value = e.target.value.replace(/\s\s+/g, ' ');

    this.setState({ value, isResultShown: true }, () => {
      this.autocomplete.search(value);
    });
  }

  focusNext() {
    if (this.input.current) {
      this.input.current.focus();
    }
  }

  onBlur() {
    // Validate the value as a valid email.
    if (isEmail(this.state.value) === true) {
      const email = this.state.value;

      let found = false;
      // Loop our already selected fields.
      this.props.fields.map((field: any, index: number) => {
        const f = this.props.fields.get(index);
        // Match emails to see if we need to add first.
        //console.warn("match", f.user.email, email)
        if (f.user.email.toLowerCase() === email.toLowerCase()) {
          found = true;
        }
      });

      if (found === false) {
        // Async search the API to replace our input with API user.
        this.getImmediate(email)
          .then((r) => {
            //console.warn("response: ", r.data );
            if (
              Array.isArray(r.data) &&
              (r.data.length === 0 || r.data[0].hits?.length === 0)
            ) {
              this.props.add({ user: { id: null, email } });
              this.resetValue();
            } else if (
              Array.isArray(r.data) &&
              r.data[0].hits &&
              Array.isArray(r.data[0].hits) &&
              r.data[0].hits.length > 0
            ) {
              // It could be one of these.
              let foundUser = false;
              for (const user of r.data[0].hits) {
                if (
                  user.email &&
                  user.email.toLowerCase() === email.toLowerCase()
                ) {
                  this.props.add({ user: user });
                  foundUser = true;
                  this.resetValue();
                  break;
                }
              }
              if (foundUser === false) {
                this.props.add({ user: { id: null, email: email } });
                this.resetValue();
              }
            } else {
              console.error(
                'We did receive something unexpected from the API.',
                r,
              );
            }
          })
          .catch((e) => {
            console.error('Exception: ', e);
          });
      } else {
        console.info('onBlur email is ALREADY in selected', email);
      }
    } else {
      console.info(
        'onBlur value is a NOT valid email',
        this.state.value,
        this.props.stopFormSubmit,
      );
      if (this.props.stopFormSubmit) {
        this.props.stopFormSubmit(this.props.formName, {
          _errors: 'Not valid email',
        });
      }
    }
  }

  onKeyDownHandling(e: any) {
    if (e.which === 13) {
      e.preventDefault();
      let user = null;

      if (this.state.highlightedIndex !== null) {
        // User explicitly selected an item from the dropdown using arrow keys
        user = this.props.elements[this.state.highlightedIndex];
      } else if (isEmail(this.state.value)) {
        // User typed a valid email address - use it directly instead of picking from suggestions
        this.onBlur();
        this.setState({
          value: '',
          isResultShown: false,
          highlightedIndex: null,
        });
        return;
      } else if (this.props.elements.length === 1) {
        // No valid email typed and no explicit selection - pick first suggestion as fallback
        user = this.props.elements[0];
      }

      if (user) {
        this.props.add({ user: user });
        this.setState({
          value: '',
          isResultShown: false,
          highlightedIndex: null,
        });
      }
    } else if (e.which === 40) {
      // Arrow down.
      e.preventDefault();
      const numberOfOptions = this.props.elements.length;

      if (!numberOfOptions) {
        return;
      }
      const highlightedIndex = this.state.highlightedIndex;
      const index =
        highlightedIndex === null || highlightedIndex === numberOfOptions - 1
          ? 0
          : highlightedIndex + 1;

      this.setState({ highlightedIndex: index });
    } else if (e.which === 38) {
      // Arrow up.
      e.preventDefault();
      const numberOfOptions = this.props.elements.length;

      if (!numberOfOptions) {
        return;
      }
      const highlightedIndex = this.state.highlightedIndex;
      const index =
        highlightedIndex === 0 || highlightedIndex === null
          ? numberOfOptions - 1
          : highlightedIndex - 1;

      this.setState({ highlightedIndex: index });
    }
  }

  cleanPaste(e: React.ClipboardEvent<HTMLTextAreaElement>) {
    if (e.clipboardData && typeof e.clipboardData.getData === 'function') {
      e.preventDefault();
      const text = e.clipboardData
        .getData('text/plain')
        .trim()
        .replace(/(?:\r\n|\r|\n)/g, '');
      this.onChangeInput({
        target: { value: text },
      });
    } else {
      this.onChangeInput(e);
    }
  }

  getRequesters() {
    const { elements, status, ElementItem, add } = this.props;

    const { value } = this.state;

    let requesters;

    const listUsers = (user: any, index: number): React.ReactNode => {
      let highlighted = false;

      if (this.state.highlightedIndex === index) {
        highlighted = true;
      }

      if (
        user.email !== undefined &&
        user.email !== null &&
        typeof user.email === 'string' &&
        user.email.trim() !== ''
      ) {
        return (
          <ElementItem
            // Duplicates has same ids, add index to prevent duplicate keys
            key={user.id + user.duplicate ? index : ''}
            add={add}
            user={user}
            highlighted={highlighted}
            resetValue={this.resetValue}
            closeDropDown={this.handleClickOutside}
          />
        );
      }
      return null;
    };
    if (status === 'loading') {
      // We are fetching the elements.
      requesters = (
        <FlexBox justifyContent="center" alignItems="center" padding="300">
          <Spinner size={20} />
        </FlexBox>
      );
    } else if (
      elements.length === 0 &&
      status === 'succeeded' &&
      value.length >= 2 &&
      isEmail(value) === true
    ) {
      requesters = null;
    } else if (
      elements.length === 0 &&
      status === 'succeeded' &&
      value.length >= 2
    ) {
      requesters = (
        <FlexBox justifyContent="center" alignItems="center" padding="300">
          <Text.Paragraph as="div" variant="2" subdued>
            No user found
          </Text.Paragraph>
        </FlexBox>
      );
    } else if (status === 'failed') {
      requesters = (
        <FlexBox justifyContent="center" alignItems="center" padding="300">
          <Text.Paragraph as="div" variant="2" color="error">
            Something went wrong
          </Text.Paragraph>
        </FlexBox>
      );
    } else if (elements.length > 0 && value.length > 1) {
      requesters = elements.map(listUsers);
    } else if (status === 'succeeded' && value.length === 0) {
      requesters = null;
    } else if (value.length > 0) {
      requesters = null;
    }

    return requesters;
  }

  render() {
    const {
      fields,
      formName,
      onFocusFunction,
      onBlurFunction,
      placeholder,
      numberOfResults,
    } = this.props;
    const { value, isResultShown } = this.state;
    const requesters = this.getRequesters();

    return (
      <div
        className={classnames('user-search-wrapper', {
          hidden: this.props.isShown === false,
        })}
      >
        <textarea
          id="autocomplete-user"
          ref={this.input}
          className={classnames(styles.emailForm, 'form-control user-search')}
          spellCheck="false"
          autoComplete="new-password"
          onKeyDown={this.onKeyDownHandling}
          onFocus={(e: any) => {
            this.setState({ isResultShown: true });
            if (onFocusFunction && typeof onFocusFunction === 'function') {
              onFocusFunction(e);
            }
          }}
          onBlur={(e: any) => {
            this.onBlur();
            this.props.touch(formName, fields.name);
            if (onBlurFunction && typeof onBlurFunction === 'function') {
              onBlurFunction(e);
            }
          }}
          onPaste={this.cleanPaste}
          placeholder={placeholder}
          onChange={this.onChangeInput}
          value={value}
        />
        <div
          className={`dropdown-result-list user-list ${
            isResultShown ? '' : 'hidden'
          }`}
          role="menu"
          aria-expanded={isResultShown && !!requesters}
        >
          {requesters}
        </div>
        {value.length >= 2 && isResultShown && numberOfResults > 0 && (
          <div className={styles.numberOfResults}>
            {`${numberOfResults} ${
              numberOfResults === 1 ? 'result' : 'results'
            }`}
          </div>
        )}
      </div>
    );
  }
}

export default OnClickOutside(AutocompleteUserAsync);
